export default __webpack_public_path__ + "static/media/fortune_card.e116df4a.png";